import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

const questions: Question[] = [
    {
        question: "TP-Link",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <p>
                        <strong>TP-Link har forskellige interfaces &ndash; Billederne herunder er taget fra en TP-Link Archer AX50.</strong>
                    </p>
                </div>
            </div>
            <div className="article">
                <ol className="list list--number list--image">
                    <li>
                        <p>
                            Log ind i routerens interface.
                        </p>
                    </li>
                    <li>
                        <p>
                            Indstil routeren til at hente IP automatisk fra os ved at gå ind i <strong>Advanced</strong> {">"}
                            <strong>Network</strong> {">"} <strong>Internet</strong> og indstille følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Internet Connection Type:</strong> Dynamic IP</p></li>
                                <li><p><strong>MAC Clone:</strong> Do NOT Clone MAC Address</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplink1}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Archer AX50&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Opret VLAN-tagget ved at gå ind i <strong>Advanced</strong> {">"} <strong>Network</strong> {">"}
                            <strong>IPTV</strong> og indstille følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>IPTV:</strong> Enable</p></li>
                                <li><p><strong>ISP Profile:</strong> Custom</p></li>
                                <li><p><strong>Internet VLAN ID:</strong> 101</p></li>
                                <li><p><strong>Internet VLAN Priority:</strong> 0</p></li>
                                <li><p><strong>VoIP VLAN ID:</strong> (Vilkårligt VLAN &ndash; I dette eksempel bruger vi bare 2)</p></li>
                                <li><p><strong>VoIP VLAN Priority:</strong> 0</p></li>
                                <li><p><strong>IPTV VLAN ID:</strong> (Vilkårligt VLAN &ndash; I dette eksempel bruger vi bare 3)</p></li>
                                <li><p><strong>IPTV VLAN Priority:</strong> 0</p></li>
                                <li><p><strong>802.1Q Tag:</strong> Slået til</p></li>
                                <li><p><strong>Alle LAN Porte:</strong> Internet</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplink2}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Archer AX50&lsquo;s interface."
                    />
                </ol>
                <div className="paragraph">
                    <p>
                        Når du har gennemgået ovenstående guide og alt er opsat, burde routeren automatisk komme online.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "TP-Link Deco (App)",
        answer: <>
            <div className="article">
                <ol className="list list--number list--image">
                    <li>
                        <p>
                            Åbn appen.
                            Tryk på knappen <strong>More</strong> nede i højre hjørne og derefter <strong>Advanced</strong>.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplinkdeco1}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Deco&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Tryk på knappen <strong>IPTV/VLAN</strong>.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplinkdeco2}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Deco&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Aktivér <strong>IPTV/VLAN</strong> og tryk på <strong>Mode</strong>.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplinkdeco3}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Deco&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Rul ned i bunden og vælg <strong>Custom</strong>.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplinkdeco4}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Deco&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Til sidst skal du indstille følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Internet VLAN ID:</strong> 101</p></li>
                                <li><p><strong>Internet VLAN Priority:</strong> 0</p></li>
                                <li><p><strong>802.1Q Tag:</strong> Aktiveret</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlantplinkdeco5}
                        alt="Billede af nogle specifikke indstillinger i TP-Link Deco&lsquo;s interface."
                    />
                </ol>
                <div className="paragraph">
                    <p>
                        Når du har gennemgået ovenstående guide og alt er opsat, burde routeren automatisk komme online.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "ASUS",
        answer: <>
            <div className="article">
                <ol className="list list--number list--image">
                    <li>
                        <p>
                            Log ind i routerens interface.
                        </p>
                    </li>
                    <li>
                        <p>
                            Indstil VLAN-tagget ved at gå ind i <strong>Advanced Setup</strong> {">"} <strong>LAN</strong> {">"}
                            <strong>IPTV</strong> og indstille følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>Select ISP Profile:</strong> Manual Setting</p></li>
                                <li><p><strong>Internet:</strong> VID: 101 | PRIO: 0</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlanasus1}
                        alt="Billede af nogle specifikke indstillinger i en ASUS routers interface."
                    />
                    <li>
                        <p>
                            Sæt WAN-indstillingerne til at hente IP automatisk fra os ved at gå ind i <strong>Advanced</strong> {">"}
                            <strong>Network</strong> {">"} <strong>IPTV</strong> og indstille følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>WAN Connection Type:</strong> Automatic IP</p></li>
                                <li><p><strong>Enable WAN:</strong> Yes</p></li>
                                <li><p><strong>Enable NAT:</strong> Yes</p></li>
                                <li><p><strong>Enable UPnP:</strong> Yes</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlanasus2}
                        alt="Billede af nogle specifikke indstillinger i en ASUS routers interface."
                    />
                </ol>
                <div className="paragraph">
                    <p>
                        Når du har gennemgået ovenstående guide og alt er opsat, burde routeren automatisk komme online.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "Netgear",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <p>
                        Denne guide omhandler kun Nighthawk routerne.
                        Netgear har andre routere, som vi desværre ikke har en vejledning til &ndash; har du en anden Netgear router kan du prøve at følge vejledningen alligevel.
                    </p>
                    <p>
                        Netgears Nighthawk routere burde på de fleste modeller understøtte VLAN-tags, men det er desværre ikke alle.
                    </p>
                </div>
            </div>
            <div className="article">
                <ol className="list list--number list--image">
                    <li>
                        <p>
                            Tilgå routerens interface (GUI).
                        </p>
                    </li>
                    <li>
                        <p>
                            Gå ind i <strong>Advanced</strong> {">"} <strong>Advanced Setup</strong> {">"} <strong>VLAN/IPTV Setup</strong>.
                            Sæt flueben i <strong>Enable VLAN/IPTV Setup</strong>, markér rækken og tryk derefter <strong>Edit</strong> for at ændre den eksisterende VLAN-regel.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlannetgear11}
                        alt="Billede af nogle specifikke indstillinger i Netgear Nighthawk&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Ændr reglen, så den har følgende værdier:
                            <ul className="list list--bullet list--compact">
                                <li><p><strong>VLAN ID:</strong> 101</p></li>
                                <li><p><strong>Priority:</strong> 0</p></li>
                            </ul>
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlannetgear12}
                        alt="Billede af nogle specifikke indstillinger i Netgear Nighthawk&lsquo;s interface."
                    />
                    <li>
                        <p>
                            Tryk herefter <strong>Apply</strong> på næste side, så ændringerne gemmes helt.
                        </p>
                    </li>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlannetgear13}
                        alt="Billede af nogle specifikke indstillinger i Netgear Nighthawk&lsquo;s interface."
                    />
                </ol>
                <div className="paragraph">
                    <p>
                        Når ovenstående er opsat, burde routeren automatisk komme online.
                    </p>
                </div>
            </div>
            <div className="article">
                <ol className="list list--number list--image">
                    <p>
                        Da Netgear har flere forskellige interfaces, er der også nogle andre billeder her &ndash; De er fra en Netgear XR500.
                    </p>
                    <img
                        src={imageMap.help.network.vlan_taggning.vlannetgear21}
                        alt="Billede af nogle specifikke indstillinger i Netgear XR500&lsquo;s interface."
                    />
                    <img
                        src={imageMap.help.network.vlan_taggning.vlannetgear22}
                        alt="Billede af nogle specifikke indstillinger i Netgear XR500&lsquo;s interface."
                    />
                </ol>
            </div>
        </>
    },
    {
        question: "Ubiquiti",
        answer: <>
            <div className="article">
                <div className="paragraph">
                    <ol className="list list--number">
                        <li>
                            <p>
                                Log ind i routerens interface.
                            </p>
                        </li>
                        <li>
                            <p>
                                Gå ind i <strong>Networks</strong> {">"} <strong>WAN</strong> og indstil følgende værdi:
                                <ul className="list list--bullet list--compact">
                                    <li><p><strong>Use VLAN ID:</strong> Tjek | 101</p></li>
                                </ul>
                            </p>
                            <p>
                                Det er valgfrit hvilken <strong>DNS Server</strong> der indstilles. Vi anbefaler 8.8.8.8 | 8.8.4.4 som er Googles DNS server.
                            </p>
                        </li>
                        <img
                            src={imageMap.help.network.vlan_taggning.vlanubiquiti}
                            alt="Billede af nogle specifikke indstillinger i en Ubiquiti routers interface."
                        />
                    </ol>
                    <p>
                        Når du har gennemgået ovenstående guide og alt er opsat, burde routeren automatisk komme online.
                    </p>
                </div>
            </div>
        </>
    }
]

export default function VLANTaggingArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Hos Hiper kan du godt bruge dit eget udstyr på din forbindelse.
                            Hvis du har fibernet kan du VLAN-tagge din egen router, så den kan snakke sammen med vores trafik.
                        </p>
                        <p>
                            Er du i tvivl, om du kan bruge din egen router på din forbindelse?
                            Du kan læse mere om eget udstyr lige <Link to="/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr">her</Link>!
                        </p>
                    </div>
                </div>
                <div className="article">
                    <h2>
                        Hvad er VLAN-tagging?
                    </h2>
                    <div className="paragraph">
                        <p>
                            Vi bruger VLAN-tagging til at forbinde en router til vores netværk. Derfor kræver det at den router du vil forbinde understøtter dette.
                        </p>
                        <p>
                            VLAN-tagging kan sammenlignes med at tale i walkie-talkie.
                            Du kan sagtens tale ud i verden, men skal modtageren i den anden ende høre hvad du siger, så skal de indstilles på samme kanal.
                        </p>
                        <p>
                            Vi sender vores trafik ud på VLAN 101 og din router skal så VLAN-tagges til 101.
                        </p>
                        <p>
                            Derudover skal den trække IP-adresse automatisk via DHCP og så burde det bare virke.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>Vælg din router og kom i gang</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "kan-jeg-bruge-mit-eget-udstyr",
                        "name": "Kan jeg bruge mit eget udstyr?"
                    },
                    {
                        "category": "udstyr",
                        "article": "bridge-mode",
                        "name": "Bridge mode"
                    },
                    {
                        "category": "udstyr",
                        "article": "ip-adresse",
                        "name": "IP-adresse"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    }
                ]}
            />
        </>
    )
}
